function normalizeApiOrigin(value) {
  const origin = value?.replace(/\/$/, "").trim();
  if (!origin) return "http://localhost:4000";

  return origin;
}

/** Public API host (no trailing slash). Single source of truth for remote API. */
export const API_ORIGIN = normalizeApiOrigin(
  process.env.REACT_APP_API_URL || process.env.REACT_APP_BASE_URL
);

/** Base URL with trailing slash for string concat with `api/v1/...` paths. */
export const API_BASE_URL = `${API_ORIGIN}/`;
